import request from '@/request/request'


// 新增设备
export function uploadFile(data) {
    let form = new FormData();
    form.append("file", data);
    return request({
        url: '/api/file-server/upload',
        method: 'post',
        data: form,
        headers: {
            // ignoreValidate: true,
            "Content-Type":"multipart/form-data"
        }
    })
}

